import React, { useEffect } from "react";
import "./styles.scss";
import { HashRouter, Route, Router } from "react-router-dom";
import { history } from "./history";
import { Signup } from "./signup";
import Box from "schoolUiComponents/basic/Box";
import { Login } from "./login";
import { MergeStudent } from "./MergeStudent";
import { ForgetPassword } from "./forgetPassword";
import { ResetPassword } from "./forgetPassword/resetPassword";

const PtlSignupView = () => {
  return (
    <Box className="ptl-signup-view" fullWidth>
      <input type="hidden"/>
      <div className="ajax_spinner" id="ajax-spinner-id"></div>
      <Router history={history}>
        {/* /ptl-setup */}
        <Route exact path="/ptl-setup" component={Signup} />
        <Route path="/ptl-login" component={Login} />
        <Route path="/ptl-setup/replace-child-page" component={MergeStudent} />
        <Route path="/ptl/forgot_password" component={ForgetPassword} />
        <Route path="/ptl/reset_password" component={ResetPassword} />
      </Router>
    </Box>
  );
};

export default PtlSignupView;
